import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { CrudService } from './crud.service';
import { Observable } from 'rxjs';
import { SharedFunctions } from '../shared.functions';
import { ConversionMoneda,  GenericResponse, SaveConversionMoneda, SearchConversionMonedaRequest } from '../model';

@Injectable({
  providedIn: 'root'
})
export class ConversionMonedaService extends CrudService<ConversionMoneda, number, SaveConversionMoneda, SearchConversionMonedaRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'MonedaConversion', sharedFunctions);

  }

  getUltimaCotizacion(monedaOrigenId: number, monedaDestinoId: number): Observable<GenericResponse<ConversionMoneda>>{
    return this._http.get<GenericResponse<ConversionMoneda>>(this._serviceUrl + '/convert/' + monedaOrigenId + '/' + monedaDestinoId, this.httpOptions);
  }
}